import { Route, Routes } from "react-router-dom";

import { NotFoundScreen } from "screens/NotFoundScreen";
import { CountryListScreen } from "screens/App/CRM/Country/CountryListScreen";
import { CountryDetailScreen } from "screens/App/CRM/Country/CountryDetailScreen";

export const CountryRouter = () => {
  return (
    <Routes>
      <Route path="list" element={<CountryListScreen />} />

      <Route path=":id/detail" element={<CountryDetailScreen />} />

      <Route path="*" element={<NotFoundScreen />} />
    </Routes>
  );
};
